import { render } from "./addcategory.vue?vue&type=template&id=7d8116ec"
import script from "./addcategory.vue?vue&type=script&lang=js"
export * from "./addcategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__